import React from "react";
import Input from "../../../../Components/Common/Input";
import Selector from "../../../../Components/Common/Selector";
import { RoleApiUrls } from "../../../../Api/Auth/ApiUrls";
import useSWR from "swr";
import { useAuth } from "../../../../Context/AuthContext";

const UserForm = ({ onChange, handleSubmit, errors, formData }) => {
  const { isLoading, data } = useSWR(RoleApiUrls.list(""));
  const { userData } = useAuth();

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <Selector
        name="roleId"
        label={`User Role`}
        required
        value={formData?.roleId}
        options={data?.data
          ?.filter((item) =>
            [0, 1].includes(userData?.roleId) ? true : item.roleId !== 6
          )
          .map((result) => ({
            value: result.roleId.toString(),
            label: result.roleName,
          }))}
        isClearable={false}
        onChange={onChange}
        error={errors?.roleId}
        isLoading={isLoading}
      />
      <Input
        label="Name"
        type="text"
        name="name"
        value={formData.name}
        onChange={onChange}
        placeholder="Enter your name"
        error={errors.name}
        required
      />
      <Input
        label="Email"
        type="email"
        name="email"
        value={formData.email}
        onChange={onChange}
        placeholder="Enter your email"
        error={errors.email}
        required
      />
      <Input
        label="Password"
        type="password"
        name="password"
        value={formData.password}
        onChange={onChange}
        placeholder="Enter your password"
        error={errors.password}
        required
      />

      {/*Reset Password Field */}

      <Input
        label="Confirm Password"
        type="password"
        name="confirmPassword"
        value={formData.confirmPassword}
        onChange={onChange}
        placeholder="Confirm your password"
        error={errors.confirmPassword}
        required
      />
      <Input
        label="Organization/University/Institute/Others"
        type="text"
        name="organization"
        value={formData.organization}
        onChange={onChange}
        placeholder="Enter your organization"
        error={errors.organization}
        required
      />
    </form>
  );
};

export default UserForm;
